import {type GetterTree} from 'vuex';

const getters: GetterTree<ModuleShiftScheduleState, RootState> = {
};

export default getters;